
import { Router } from './types'
import { BasicLayout, RouteView } from '@/layouts'
const asnycRoutersMap={
  system:{
    name:'system',
    path:'/system',
    component:RouteView,
    redirect: '/setting',
    meta:{title:'menu.system',icon: 'bx-analyse',}
  },
  setting:{
    name:'setting',
    path:'/setting',
    component: () => import('@/views/system/setting.vue'),
    meta:{title:'menu.setting',icon: 'bx-analyse',}
  },
  roles:{
    name:'rule',
    path:'/rule',
    component: () => import('@/views/system/rule.vue'),
    meta:{title:'menu.rule',icon: 'bx-analyse',}
  },
  menus:{
    name:'menu',
    path:'/menu',
    component: () => import('@/views/system/menu.vue'),
    meta:{title:'menu.menu',icon: 'bx-analyse',}
  },
  words:{
    name:'words',
    path:'/words',
    component: () => import('@/views/system/words.vue'),
    meta:{title:'menu.words',icon: 'bx-analyse',}
  },
  logs:{
    name:'logs',
    path:'/system/logs',
    component: () => import('@/views/system/logs.vue'),
    meta:{title:'menu.logs',icon: 'bx-analyse',}
  },

  products:{
    name:'products',
    path:'/products',
    component:RouteView,
    redirect: '/products/product',
    meta:{title:'menu.products',icon: 'bx-analyse',}
  },
  product:{
    name:'product',
    path:'/products/product',
    component:() => import('@/views/products/product.vue'),
    meta:{title:'menu.product',icon: 'bx-analyse',}
  },
  protype:{
    name:'protype',
    path:'/products/protype',
    component:() => import('@/views/products/protype.vue'),
    meta:{title:'menu.protype',icon: 'bx-analyse',}
  },

  users:{
    name:'users',
    path:'/users',
    component:() => import('@/views/user/Index.vue'),
    meta:{title:'menu.user',icon: 'bx-analyse',}
  },

  companly:{
   name:'companly',
    path:'/companly',
    component:() => import('@/views/companly/index.vue'),
    meta:{title:'menu.companly',icon: 'bx-analyse',}
  },

  page:{
    name:'page',
    path:'/page',
    component:RouteView,
    redirect: '/page/custompage',
    meta:{title:'menu.page',icon: 'bx-analyse',}
  },
  section:{
    name:'section',
    path:'/page/section',
    component: () => import('@/views/page/section.vue'),
    meta:{title:'menu.section',icon: 'bx-analyse',}
  },
  custompage:{
    name:'custompage',
    path:'/page/custompage',
    component: () => import('@/views/page/custompage.vue'),
    meta:{title:'menu.custompage',icon: 'bx-analyse',}
  },
  navigate:{
    name:'navigate',
    path:'/page/navigate',
    component: () => import('@/views/page/navigate.vue'),
    meta:{title:'menu.navigate',icon: 'bx-analyse',}
  },

  list:{
    name:'list',
    path:'/list',
    component:RouteView,
    redirect: '/list/index',
    meta:{title:'menu.list',icon: 'bx-analyse',}
  },
  listview:{
    name:'listview',
    path:'/list/index',
    component:() => import('@/views/list/index.vue'),
    meta:{title:'menu.listview',icon: 'bx-analyse',}
  },
  cancellist:{
    name:'cancellist',
    path:'/list/cancellist',
    component:() => import('@/views/list/cancellist.vue'),
    meta:{title:'menu.cancellist',icon: 'bx-analyse',}
  },
  devices:{
    name:'devices',
    path:'/devices',
    component:RouteView,
    redirect: '/device/device',
    meta:{title:'menu.devices',icon: 'bx-analyse',}
  },
  device:{
    name:'device',
    path:'/device',
    component:() => import('@/views/device/device.vue'),
    meta:{title:'menu.device',icon: 'bx-analyse',}
  },
  devicemoniter:{
    name:'devicemoniter',
    path:'/devicemoniter',
    component:() => import('@/views/device/devicemoniter.vue'),
    meta:{title:'menu.devicemoniter',icon: 'bx-analyse',}
  },
  devicegroup:{
    name:'devicegroup',
    path:'/devicegroup',
    component:() => import('@/views/device/devicegroup.vue'),
    meta:{title:'menu.devicegroup',icon: 'bx-analyse',}
  },
  devicealarm:{
    name:'devicealarm',
    path:'/devicealarm',
    component:() => import('@/views/device/devicealarm.vue'),
    meta:{title:'menu.devicealarm',icon: 'bx-analyse',}
  },
  rpclogs:{
    name:'rpclogs',
    path:'/rpclogs',
    component:() => import('@/views/device/rpclogs.vue'),
    meta:{title:'menu.rpclogs',icon: 'bx-analyse',}
  },
  gateway:{
    name:'gateway',
    path:'/gateway',
    component:RouteView,
    meta:{title:'menu.gateway',icon: 'bx-analyse',}
  },
  driver:{
    name:'driver',
    path:'/driver',
    component:() => import('@/views/gateway/driver.vue'),
    meta:{title:'menu.driver',icon: 'bx-analyse',}
  },
  systemconfig:{
    name:'systemconfig',
    path:'/systemconfig',
    component:() => import('@/views/gateway/systemconfig.vue'),
    meta:{title:'menu.systemconfig',icon: 'bx-analyse',}
  },

  jobs:{
    name:'jobs',
    path:'/jobs',
    component:() => import('@/views/gateway/jobs.vue'),
    meta:{title:'menu.jobs',icon: 'bx-analyse'}
  },
  combination:{
    name:'combination',
    path:'/combination',
    component:RouteView,
    meta:{title:'menu.combination',icon: 'bx-analyse',}
  },

  sceneconfig:{
    name:'sceneconfig',
    path:'/sceneconfig',
    component:() => import('@/views/combination/sceneconfig.vue'),
    meta:{title:'menu.sceneconfig',icon: 'bx-analyse',}
  },
  combination2d:{
    name:'combination2d',
    path:'/combination2d',
    component:() => import('@/views/combination/scene2d.vue'),
    meta:{title:'menu.combination2d',icon: 'bx-analyse',}
  },
  combination3d:{
    name:'combination3d',
    path:'/combination3d',
    component:() => import('@/views/combination/scene3d.vue'),
    meta:{title:'menu.combination3d',icon: 'bx-analyse',}
  },
  scaner:{
    name:'scaner',
    path:'/scaner',
    component:() => import('@/views/scaner/index.vue'),
    meta:{title:'menu.scaner',icon: 'bx-analyse',}
  },
  camara:{
    name:'camara',
    path:'/camara',
    component:() => import('@/views/camara/index.vue'),
    meta:{title:'menu.camara',icon: 'bx-analyse',}
  }
}
export default asnycRoutersMap
